import type { Node } from '@xyflow/react';

export const ACTION = 'action';
export const DECISION = 'decision';
export const END = 'end';
export const START = 'start';

export const DECISION_RESULT_LABELS: Record<'true' | 'false', string> = {
  true: 'IF_TRUE',
  false: 'IF_FALSE',
};

/**
 * Human-readable UI labels for node types.
 * Derived from the flow-nodes items schema (see core `schemas.ts`):
 * - When rendering flow nodes, labels are resolved from each node type's schema
 *   using its `x-entity-label` within the items'
 *   `oneOf` entries that represent available node types.
 */
export type NodeTypeLabelMap = Record<'action' | 'decision', string>;

/**
 * Per-node-type property key that contains the "next" connections.
 *
 * Configured via `FlowControlOptions.nodeOptions[<type>].next` in core `schemas.ts`.
 * If not provided, the key defaults to "next".
 *
 * Notes:
 * - 'end' is omitted because terminal End nodes have no outgoing connections.
 */
export type NodeNextKeyMap = Record<'action' | 'decision' | 'start', string>;

export type NodeType =
  | typeof ACTION
  | typeof DECISION
  | typeof END
  | typeof START;

export type DetailNodeType = Exclude<NodeType, typeof END | typeof START>;

export type TerminalNodeType = typeof END | typeof START;

export type DecisionNextResult = 'true' | 'false';

/**
 * Used for decision nodes to connect to other nodes based on the result
 */
export interface DecisionNext {
  nextNodeId: string;
  result: DecisionNextResult;
}
export interface FlowNode {
  nodeId: string;
  nodeType: NodeType;
  nodeLabel?: string;
  /**
   * next is to connect other nodes
   */
  next?: Array<DecisionNext> | Array<string>;
  [key: string]: any;
}

export type LayoutNode = Node & { type: NodeType };
